import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAuth } from "@/context/auth-context";
import { jsonAuthHeaders } from "@/utils/headers";
import { ENDPOINTS } from "@/api/application-api";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { useParams } from "react-router-dom";

export const useDeleteDatasetColumn = () => {
  const auth = useAuth();
  const userToken = auth?.userToken;
  const { workspaceId, datasetGroupId, datasetId } = useParams();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (columnName: string) => {
      return fetch(
        `${ENDPOINTS.delete_dataset_column(
          Number(workspaceId),
          Number(datasetGroupId),
          Number(datasetId),
        )}`,
        {
          method: "DELETE",
          headers: jsonAuthHeaders(userToken!),
          body: JSON.stringify({
            column_name: columnName,
          }),
        },
      ).then(handleResponse);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [ENDPOINTS.dataset_rows],
      });
    },
  });
};
